import { Grid, Paper } from '@material-ui/core';
import React from 'react';
import { EnvelopeIcon, NoteIcon, PhoneIcon, UserGroupIcon } from '../../../icons';
import CartItemInfo from '../../cart/components/CartItemInfo';
import { formatPhone } from '../../../helpers/phoneUtils';

const VendorInfo = ({ activity, loading, error }) => {
    if (loading || error) {
        return null;
    }

    return (
        <Grid item>
            <Paper className="colorcard padded vendor-info" elevation={2}>
                <CartItemInfo
                    icon={<UserGroupIcon />}
                    title="Vendor"
                    value={activity.company?.name}
                />
                <CartItemInfo
                    icon={<PhoneIcon />}
                    title="Phone"
                    value={formatPhone(activity.company?.contact_phone?.reservation)}
                />
                <CartItemInfo
                    icon={<EnvelopeIcon />}
                    title="Email"
                    value={activity.company.contact_email?.reservation}
                />
                <CartItemInfo icon={<NoteIcon />} title="Notes" value={activity.vendor_notes} />
            </Paper>
        </Grid>
    );
};

export default VendorInfo;
